
import './App.css';
import React, { useState  } from 'react';

import ProductPageCom from './ProductPage.jsx';

function App() {

  const handleClick = () => {
    window.open("https://www.amazon.com/dp/B0DGXQWPC9?maas=maas_adg_5A0FAE07CB440A41C1B0C8BBC692E6AF_afap_abs&ref_=aa_maas&tag=maas", "_blank");
  };

  return (
    <div className="App">
      <header className="App-header">
       
      <ProductPageCom /> 

       {/* 固定在底部的按钮 */}
       <button className="fixed-button" onClick={handleClick}>
          <span className="button-text">Buy with Prime</span>
          <img src="/goto.svg" alt="Prime Icon" className="button-icon" />
       </button>
      </header>
    </div>
  );
}

export default App;
